import { useNavigate, useLocation } from 'react-router-dom';
import { useCallback } from 'react';
import {accountingHelpers, tabHelpers} from '../utils/helpers';

export const useAccountingTabLogic = ({
  tabKeys,
  tableData,
  setTableData,
  queries,
  setQueries,
  requiredUpdate,
  loadData,
  setActiveTabKey,
  setSelectedRowKeys,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getTableDataValue = useCallback((view, key, defaultValue) =>
    accountingHelpers.getTableDataValue(tableData, view, key, defaultValue),
  [tableData]);

  const handleOnPaginate = useCallback((view, activePage) =>
    tabHelpers.handleOnPaginate({view, activePage, tableData, setTableData, loadDataFunc: loadData}),
  [tableData, setTableData, loadData]);

  const handleRowSelect = useCallback((view, value) => {
    setSelectedRowKeys(prevState => ({
      ...prevState,
      [view]: value
    }));
  }, [setSelectedRowKeys]);

  const handleOnTableChange = useCallback((view, pagination, filters, sorter, extra) =>
    tabHelpers.handleOnTableChange({view, sorter, extra, loadDataFunc: loadData}),
  [loadData]);

  const handleOnFilter = useCallback((view, filterQuery) =>
    tabHelpers.handleOnFilter({view, filterQuery, loadDataFunc: loadData, queries, setQueries}),
  [setQueries, queries, loadData]);

  const updateTab = useCallback((key) => {
    navigate(`${location.pathname}#${key}`);
    setActiveTabKey?.(key);
  }, [navigate, location.pathname, setActiveTabKey]);

  const onChangeTab = useCallback((key) => {
    const view = tabKeys[key.toUpperCase()];
    updateTab(key);

    if (!getTableDataValue(view, 'loaded', false) || requiredUpdate[view]) {
      loadData({view, initial: true});
    }
  }, [tabKeys, updateTab, getTableDataValue, requiredUpdate, loadData]);

  return {
    handleOnPaginate,
    handleRowSelect,
    handleOnTableChange,
    handleOnFilter,
    onChangeTab,
    updateTab,
  };
}

